import React from "react";
import GAClassroomAudioReactionsContainer from "../../modules/GAClassroomAudioReactions/containers/GAClassroomAudioReactionsContainer/GAClassroomAudioReactionsContainer";

const GAClassroomAudioReactions = () => {
  return <GAClassroomAudioReactionsContainer />;
};

export default GAClassroomAudioReactions;
